import { connect } from 'react-redux';

import StatementEditPage from 'pages/statement-edit-page';
import { finishStatementEdit } from 'store/actions/statement-edit-actions';
import { updateSelectedProjectFromIDIfDoesNotExists } from 'store/actions/selected-project-actions';

const mapDispatchToProps = {
  finishStatementEdit,
  updateSelectedProjectFromIDIfDoesNotExists,
};

export default connect(null, mapDispatchToProps)(StatementEditPage);
